module.exports = __webpack_public_path__ + "static/media/sunEclipse.4865b190.svg";